export default __webpack_public_path__ + "static/media/bz white.6742e754.svg";